
/**
 * @export
 * @enum {string}
 */
export enum AlertFrequencyType {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    NONE = 'NONE'
}